import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  return {
    files: required(get(values, 'files[0].url')),
  }
}

export default validate
